import BasePage from "../BasePage";
import FormulaireDeclaration from "../components/web/FormulaireDeclaration";

const DeclarationFormulaire = () => {
    return ( 
    <BasePage>
        <FormulaireDeclaration/>
    </BasePage>
    );
}
 
export default DeclarationFormulaire;